import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMode, MODES } from '../context/ModeContext';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import {
    LuBitcoin,
    LuLandmark,
    LuTrendingUp,
    LuShield,
    LuZap,
    LuGlobe,
    LuArrowRight
} from 'react-icons/lu';

function ModeSelectorPage() {
    const navigate = useNavigate();
    const { setMode } = useMode();
    const { lang } = useLanguage();
    const { user } = useAuth();

    const handleSelectMode = (selectedMode) => {
        setMode(selectedMode);
        navigate(selectedMode === MODES.CRYPTO ? '/crypto' : '/fiat');
    };

    const content = {
        tr: {
            welcome: 'Hoş Geldiniz',
            welcomeUser: `Hoş Geldiniz, ${user?.name || 'Kullanıcı'}`,
            subtitle: 'Yatırım türünüzü seçin',
            crypto: {
                title: 'Kripto Para',
                description: 'Bitcoin, Ethereum ve diğer kripto varlıklarınızı yönetin',
                features: ['Anlık fiyat takibi', 'Yüksek volatilite analizi', 'DeFi getiri hesaplama']
            },
            fiat: {
                title: 'Gerçek Para',
                description: 'TL, Dolar ve Euro yatırımlarınızı planlayın',
                features: ['Banka faiz hesaplama', 'Güvenli yatırım analizi', 'Döviz karşılaştırma']
            },
            select: 'Seç'
        },
        en: {
            welcome: 'Welcome',
            welcomeUser: `Welcome, ${user?.name || 'User'}`,
            subtitle: 'Choose your investment type',
            crypto: {
                title: 'Cryptocurrency',
                description: 'Manage your Bitcoin, Ethereum and other crypto assets',
                features: ['Real-time price tracking', 'High volatility analysis', 'DeFi yield calculation']
            },
            fiat: {
                title: 'Fiat Currency',
                description: 'Plan your TRY, USD and EUR investments',
                features: ['Bank interest calculation', 'Safe investment analysis', 'Currency comparison']
            },
            select: 'Select'
        }
    };

    const t = content[lang] || content.en;

    return (
        <div className="mode-selector-page">
            <div className="mode-selector-background">
                <div className="bg-gradient-1"></div>
                <div className="bg-gradient-2"></div>
            </div>

            <div className="mode-selector-container">
                <div className="mode-selector-header">
                    <div className="mode-selector-logo">G</div>
                    <h1>{user ? t.welcomeUser : t.welcome}</h1>
                    <p>{t.subtitle}</p>
                </div>

                <div className="mode-selector-cards">
                    {/* Crypto Card */}
                    <div
                        className="mode-card mode-card-crypto"
                        onClick={() => handleSelectMode(MODES.CRYPTO)}
                    >
                        <div className="mode-card-glow"></div>
                        <div className="mode-card-icon">
                            <LuBitcoin />
                        </div>
                        <h2>{t.crypto.title}</h2>
                        <p>{t.crypto.description}</p>
                        <ul className="mode-card-features">
                            {t.crypto.features.map((feature, index) => (
                                <li key={index}>
                                    {index === 0 && <LuTrendingUp />}
                                    {index === 1 && <LuZap />}
                                    {index === 2 && <LuShield />}
                                    {feature}
                                </li>
                            ))}
                        </ul>
                        <button className="mode-card-btn">
                            {t.select} <LuArrowRight />
                        </button>
                    </div>

                    {/* Fiat Card */}
                    <div
                        className="mode-card mode-card-fiat"
                        onClick={() => handleSelectMode(MODES.FIAT)}
                    >
                        <div className="mode-card-glow"></div>
                        <div className="mode-card-icon">
                            <LuLandmark />
                        </div>
                        <h2>{t.fiat.title}</h2>
                        <p>{t.fiat.description}</p>
                        <ul className="mode-card-features">
                            {t.fiat.features.map((feature, index) => (
                                <li key={index}>
                                    {index === 0 && <LuTrendingUp />}
                                    {index === 1 && <LuShield />}
                                    {index === 2 && <LuGlobe />}
                                    {feature}
                                </li>
                            ))}
                        </ul>
                        <button className="mode-card-btn">
                            {t.select} <LuArrowRight />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModeSelectorPage;
